var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group date vue-component"},[_vm._m(0),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","name":_vm.name,"disabled":_vm.disabled,"readonly":_vm.readonly},domProps:{"value":_vm.value}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-calendar"})])
}]

export { render, staticRenderFns }